<template>
      <el-table
          :data="pointData"
          border
          style="width: 100%; height: 100%;">
        <el-table-column
            align="center"
            label="测点"
            prop="pointName">
          <template slot-scope="scope">
            <span class="largeContent">{{ scope.row.pointName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            prop="pointValueName">
          <template slot-scope="scope">
            <el-switch
              style="display: block;"
              v-model="scope.row.value"
              active-color="#13ce66"
              inactive-color="#ff4949"
              inactive-text="关"
              @change="switchDevice(scope.row)"
              active-text="开">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
</template>

<script>
import {control} from "@/network/device-measuring-point";

export default {
  name: "TableLayout",
  props: {
    pointData: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '240px'
    }
  },
  computed: {

  },
  methods:{
    //开关
    change(id, value) {
      control(this.deviceInfo.id, id, value).then(() => {
        this.$emit("control")
      })
    },
  },
}
</script>

<style scoped>
ul.pointData {
  padding-left: 0;
}

.pointData li {
  width: 238px;
  list-style: none;
  display: inline-block;
  margin: 15px 30px;
}

.pointData .el-table >>> td, .pointData .el-table >>> th {
  padding: 5px 0;
}

.pointData .el-table--border, .pointData .el-table--group {
  border-left: none;
}

.pointData .el-table >>> .el-table__header-wrapper, .pointData .el-table >>> .el-table__body-wrapper {
  border-left: 1px solid rgba(41, 155, 255, .3);
  border-right: 1px solid rgba(41, 155, 255, .3);
}
</style>
